module.exports = __webpack_public_path__ + "assets/media/kazan-slider-3.467012d2.jpg";